export default "__VITE_ASSET__9NTzHtA5__"